import { render, staticRenderFns } from "./LastSlide.vue?vue&type=template&id=28427e96&scoped=true&"
import script from "./LastSlide.vue?vue&type=script&lang=js&"
export * from "./LastSlide.vue?vue&type=script&lang=js&"
import style0 from "./LastSlide.vue?vue&type=style&index=0&id=28427e96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28427e96",
  null
  
)

export default component.exports